import CollectionPage from '~/components/module/setup/CollectionPage';
import { setupRouteAbsolute } from '~/utils/routes/setup';
import { createPersonAdapter } from '~/apis/personList';
import { ADDRESS_FIELDS } from '~/utils/helper/setupForm';
import { DEFAULT_DIAL_CODE } from '~/utils/constants/countries';
import { fullName, joinParts, str } from '~/components/module/setup/cells';
import { IFormField } from '~/utils/interface/setup';

const adapter = createPersonAdapter('emergency-contacts', 'relationship');

const fields: IFormField[] = [
  { name: 'firstName', labelKey: 'pages.setup.fields.firstName', type: 'text', required: true },
  { name: 'lastName', labelKey: 'pages.setup.fields.lastName', type: 'text', required: true },
  { name: 'relationship', labelKey: 'pages.setup.emergencyContacts.relationship', type: 'text', required: true },
  { name: 'phoneNumber', labelKey: 'pages.setup.fields.phoneNumber', type: 'phone', countryName: 'countryCode', required: true },
  ...ADDRESS_FIELDS,
];

const EmergencyContacts = () => (
  <CollectionPage
    i18nPrefix='pages.setup.emergencyContacts'
    module='seniorMedical'
    permissionAction='manageDoctorNote'
    backTo={{ path: setupRouteAbsolute.medical, labelKey: 'nav.setup.medical' }}
    adapter={adapter}
    fields={fields}
    defaultForm={{ countryCode: DEFAULT_DIAL_CODE }}
    getTitle={fullName}
    columns={[
      { key: 'name', labelKey: 'pages.setup.table.name', render: (form) => <span className='font-medium text-foreground'>{fullName(form)}</span> },
      { key: 'relationship', labelKey: 'pages.setup.emergencyContacts.relationship', render: (form) => str(form.relationship) },
      {
        key: 'phone',
        labelKey: 'pages.setup.fields.phoneNumber',
        render: (form) => joinParts([form.countryCode, form.phoneNumber], ' '),
      },
      {
        key: 'address',
        labelKey: 'pages.setup.fields.address',
        render: (form) => joinParts([form.address, form.city, form.country]),
      },
    ]}
  />
);

export default EmergencyContacts;
